import rill from "rill";
import { checkOrganizationSectionPermission } from "../../../middleware/ensure-coach-permissions";
import getDoorAccess from "./door-access.controller";

const DoorAccessRoutes = (app) => {
  app.at(
    "/door-access/*",
    rill().setup((app) => {
      app.get(
        "/",
        (ctx, next) =>
          checkOrganizationSectionPermission(
            ctx,
            next,
            ["PRESS"],
            "/coaching-portal/athletes"
          ),
        getDoorAccess
      );
    })
  );
};

export default DoorAccessRoutes;
